import { Observable } from "rxjs";
import { UseCase } from "../../../base/use-case";
import { ConfigurationRepository } from "../../../repositories/configuration.repository";
import { ConsentModel } from "../../../models/configuration/consent.model";

export class DeleteConsentUseCase implements UseCase<{ id: string}, ConsentModel> {
    constructor(private ConsentRepository: ConfigurationRepository) { }
    execute(
        params: {id: string},
    ): Observable<ConsentModel> {
        return this.ConsentRepository.deleteConsent(params);
    }
}
